module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-ab8d53568318573fa3eb95fe2f42f928.jpg";